import styled from 'styled-components';

import { Card as InnerCard } from '@xing-com/card';
import { ProfileImage } from '@xing-com/profile-image';
import {
  spaceXS,
  spaceL,
  spaceM,
  xdlColorBorder,
  xdlColorText,
} from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const HeadlineWrapper = Headline as $TSFixMe;

const innerLogoMargin = '8px';

export const Flag = styled.div`
  padding: 0 ${spaceXS};
  border-radius: 2px;
  background-color: black;
  color: white;
  margin: 0;
  font-size: 100;
`;

export const OverlayLayer = styled.div`
  z-index: 1;
  background-color: transparent;
  position: absolute;
  left: 0;
  top: 0;
  margin-top: ${spaceL};
  padding: 0 ${spaceL};
`;

export const Card = styled(InnerCard)`
  width: 100%;
  justify-content: start;
  overflow: hidden;
  min-width: 100%;
`;

export const CoverImage = styled.div`
  background-color: ${xdlColorBorder};
  width: 100%;
  padding-bottom: 56.25%;
  min-height: 120px;
  border-radius: 4px;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-bottom: ${spaceM};
`;

export const Logo = styled(ProfileImage)`
  position: absolute;
  left: ${innerLogoMargin};
  bottom: ${innerLogoMargin};
`;

export const ProfileLink = styled.a`
  color: ${xdlColorText};
`;

export const CompanyName = styled(HeadlineWrapper)`
  font-size: ${spaceL};
  margin: 0;
  color: ${xdlColorText};
  max-width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
`;

export const ButtonPanel = styled.div`
  padding-top: ${spaceM};
  display: flex;
  flex-direction: row;
  margin-top: auto;
`;
